export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_API_FORMAT = "DD-MM-YYYY";
export const DATE_API_FORMAT_MONTH = "MM-YYYY";
export const TIME_FORMAT = "HH:mm:ss";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
